'use strict';


var RemoteWallet = class {
	constructor(app) {
		this.app = app;
		this.name = 'PrimusMoney';
	}

	async getShortPaymentLink(params) {
		let start_conditions = this.app.getVariable('start_conditions');

		if (!start_conditions)
		return;
		
		var base_uri = await this.app.getRemoteWalletUrl((params.device ? params.device : null));
		var uri = base_uri;

		//
		// always added if present
		//

		uri += '?route=' + (start_conditions.remote_wallet_route ? start_conditions.remote_wallet_route : 'currencycard');

		// security
		if (start_conditions.remote_wallet_ring && (start_conditions.remote_wallet_ring == 1))
		uri += '&ring=1'; // device wallet
		else
		uri += '&ring=2'; // not device wallet (ring=1) ask to authentify to reach at least ring==2

		// currency context
		if (params.web3_provider_url)
		uri += '&web3url=' + this.app.encodebase64(params.web3_provider_url);

		if (params.cardaddress)
		uri += '&cardaddress=' + params.cardaddress;

		if (params.currencyaddress)
		uri += '&tokenaddress=' + params.currencyaddress;

		// transaction
		if (params.to_address)
		uri += '&to=' + params.to_address;

		if (params.amount)
		uri += '&amount=' + params.amount;


		//
		// added by default if present and not disabled
		//

		let link_options = start_conditions.short_payment_link_options;

		// reference id used to make the link on a backoffice
		if (params.invoice_id) {
			if ( !link_options || (link_options.invoiceid_disabled !== true))
			uri += '&invoiceid=' + params.invoice_id;
		}

		// returns
		if (params.returnurl) {
			if ( !link_options || (link_options.returnurl_disabled !== true))
			uri += '&returnurl=' + this.app.encodebase64(params.returnurl);
		}

		//
		// added only if present and enabled
		//

		// callback
		if (params.callbackurl) {
			if ( link_options && (link_options.callbackurl_enabled === true))
			uri += '&callbackurl=' + this.app.encodebase64(params.callbackurl);
		}

		if (params.code_id) {
			if ( link_options && (link_options.codeid_enabled === true))
			uri += '&codeid=' + params.code_id;
		}


		// additional data
		if (params.tx_data) {
			if ( link_options && (link_options.txdata_enabled === true)) {
				let _keys = Object.keys(params.tx_data);

				for (var i = 0; i < _keys.length; i++) {
					uri += '&' + _keys[i] + '=' + this.app.encodebase64(params.tx_data[_keys[i]]);
				}
				}

		}
		
		// additional parameters
		if (start_conditions.remote_wallet_params) {
			try {
				if ( link_options && (link_options.remotewalletparams_enabled === true)) {
					let arr = Object.entries(start_conditions.remote_wallet_params);

					for (var i = 0; i < (arr ? arr.length : 0); i++) {
						uri += '&' + arr[i][0] + '=' + arr[i][1];
					}
				}
			}
			catch(e) {
				console.log('exception in RemoteWallet.getShortPaymentLink parsing start_conditions.remote_params_string: ' + e);
			}
			
		}

		

		return uri;
	}


	async getPaymentLink(params) {
		let start_conditions = this.app.getVariable('start_conditions');

		if (!start_conditions)
		return;
		
		var base_uri = await this.app.getRemoteWalletUrl((params.device ? params.device : null));
		var uri = base_uri;

		uri += '?route=' + (start_conditions.remote_wallet_route ? start_conditions.remote_wallet_route : 'currencycard');

		// security
		if (start_conditions.remote_wallet_ring && (start_conditions.remote_wallet_ring == 1))
		uri += '&ring=1'; // device wallet
		else
		uri += '&ring=2'; // not device wallet (ring=1) ask to authentify to reach at least ring==2

			
		// additional parameters
		if (start_conditions.remote_wallet_params) {
			try {
				let arr = Object.entries(start_conditions.remote_wallet_params);

				for (var i = 0; i < (arr ? arr.length : 0); i++) {
					uri += '&' + arr[i][0] + '=' + arr[i][1];
				}
			}
			catch(e) {
				console.log('exception in RemoteWallet.getPaymentLink parsing start_conditions.remote_params_string: ' + e);
			}
			
		}

		// currency context
		if (params.web3_provider_url)
		uri += '&web3url=' + this.app.encodebase64(params.web3_provider_url);

		if (params.cardaddress)
		uri += '&cardaddress=' + params.cardaddress;

		if (params.currencyaddress)
		uri += '&tokenaddress=' + params.currencyaddress;

		// transaction
		if (params.to_address)
		uri += '&to=' + params.to_address;

		if (params.amount)
		uri += '&amount=' + params.amount;

		// reference id used to make the link on a backoffice
		if (params.invoice_id)
		uri += '&invoiceid=' + params.invoice_id;

		// callbacks and returns
		if (params.callbackurl)
		uri += '&callbackurl=' + this.app.encodebase64(params.callbackurl);

		if (params.returnurl)
		uri += '&returnurl=' + this.app.encodebase64(params.returnurl);

		if (params.code_id)
		uri += '&codeid=' + params.code_id; // we could pass an internal uuid


		// additional data
		if (params.tx_data) {
			let _keys = Object.keys(params.tx_data);

			for (var i = 0; i < _keys.length; i++) {
				uri += '&' + _keys[i] + '=' + this.app.encodebase64(params.tx_data[_keys[i]]);
			}
		}


		// encode in base64 to safely travel accross mail and messaging
		uri = base_uri + '?b64url=' + this.app.encodebase64(uri);

		return uri;
	}

	async onPay(params) {
		let uri = await this.getPaymentLink(params);

		// jump
		this.app.gotoUrl(uri);
	}

	async getTransactionInfo(sessionuuid, walletuuid, schemeuuid, txhash) {
		let mvcmywidget = this.app.getMvcMyWidget();

		var tx_info = {hash: txhash};

		try {
			// get transaction for more specific info
			let transaction = await mvcmywidget.getSchemeEthereumTransaction(sessionuuid, walletuuid, schemeuuid, txhash)
			.catch(err => {
				console.log('could not retrieve transaction in RemoteWallet.getTransactionInfo: ' + err);
			});
			let tx = (transaction ? transaction._ethtx : null);

			if (tx) {
				tx_info.time = tx.time;
				tx_info.status_int = 5; // pending

				// get transaction receipt
				let tx_receipt = await mvcmywidget.getSchemeEthereumTransactionReceipt(sessionuuid, walletuuid, schemeuuid, txhash).catch(err => {});

				if (tx_receipt) {
					tx_info.blockNumber = tx_receipt.blockNumber;
					tx_info.from_address = tx_receipt.from;
					tx_info.status = tx_receipt.status;
					tx_info.status_int = (tx_receipt.status ? 10 : -10); // 1 success, -1 fail
		
					// erc20 format
					tx_info.tokenaddress = tx_receipt.to
					tx_info.amount = (tx_receipt.logs && tx_receipt.logs[0] ? parseInt(tx_receipt.logs[0].data) : null);
					tx_info.to_address = (tx_receipt.logs && tx_receipt.logs[0] && tx_receipt.logs[0].topics && tx_receipt.logs[0].topics[2] ? '0x' + tx_receipt.logs[0].topics[2].substring(26) : null);
		
					if (tx_info.to_address) {
						let token = await mvcmywidget.getSchemeERC20TokenInfo(sessionuuid, walletuuid, schemeuuid, tx_info.tokenaddress);
						if (token) {
							let options = {};
							tx_info.amount_string = (tx_info.amount != null ? mvcmywidget.formatTokenAmount(tx_info.amount, token, options) : '');
						}
	
					}
				}
			}
			else {
				tx_info.status_int = -5; // not found
			}





		}
		catch(e) {
			console.log('exception in RemoteWallet.getTransactionInfo: ' + e);
		}

		return tx_info;
	}

}

if ( typeof window !== 'undefined' && typeof window.GlobalClass !== 'undefined' && window.GlobalClass ) {
	var _GlobalClass = window.GlobalClass;
}
else if (typeof window !== 'undefined') {
	var _GlobalClass = ( window && window.simplestore && window.simplestore.Global ? window.simplestore.Global : null);
}
else if (typeof global !== 'undefined') {
	// we are in node js
	var _GlobalClass = ( global && global.simplestore && global.simplestore.Global ? global.simplestore.Global : null);
}

_GlobalClass.registerModuleClass('mvc-mywidget', 'RemoteWallet', RemoteWallet);
